import { map } from 'lodash';

/**
 * Checks if a string value contains a number.
 *
 * @param {string} value - The value to check.
 * @returns {boolean} True if it's a number, false otherwise.
 */
export const isNumericalString = value => /^-?[\d.]+(?:e-?\d+)?$/.test(value);

/**
 * Checks if a string can be converted to number and returns it as such, or a default value if not.
 *
 * @param {object} arg - The argument object.
 * @param {string} arg.value - The value to check.
 * @param {number|string} arg.defaultValue - The default value to return if value is not a numerical string.
 * @returns {number} The value as a number or the default value if can't be converted to one.
 */
export const checkValueIsNumber = ({ value, defaultValue }) =>
  !isNumericalString(value) ? Number(defaultValue) : Number(value);

/**
 * Checks if a string array's values can be converted to number and returns them as such, or default values if not.
 *
 * @param {object} arg - The argument object.
 * @param {string[]} arg.valuesArray - The array of values to check.
 * @param {(number|string)[]} arg.defaultValuesArray - The array of default values to return if values are not numerical strings.
 * @returns {number[]} The array of values as numbers or the array of default values if can't be converted to such.
 */
export const checkArrayForNumbers = ({ valuesArray, defaultValuesArray }) => {
  return map(valuesArray, (value, index) =>
    checkValueIsNumber({ value, defaultValue: defaultValuesArray[index] })
  );
};
